import { Button, Empty, Typography } from 'antd';
import { SVGLogoLight } from '../../images';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

const NotFound = ({
  description,
  showIcon,
  showButton = true,
}: {
  description?: string;
  showIcon?: boolean;
  showButton?: boolean;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div style={{ padding: '50px 0' }}>
      <Empty
        image={showIcon ? <SVGLogoLight /> : null}
        styles={{ image: { height: 60 } }}
        description={
          <Typography.Text>{description || t('coming_soon')}</Typography.Text>
        }
      >
        {showButton && (
          <Button type="primary" onClick={() => navigate(-1)}>
            {t('go_back')}
          </Button>
        )}
      </Empty>
    </div>
  );
};

export default NotFound;
